import { MemreFlexBox } from 'components/core';
import Sound from '../Sound';

export default function SoundBlock({ item }) {
  const handleAddSound = async (url, soundId) => {
    try {
      await item.addSound(url, soundId);
    } catch (error) {
      console.error('Error adding sound:', error);
    }
  };

  const handleDeleteSound = async () => {
    try {
      // Pass null to remove the sound relationship
      await item.addSound('', null);
    } catch (error) {
      console.error('Error removing sound:', error);
    }
  };

  return (
    <MemreFlexBox
      direction="row"
      gap={1}
      justify="center"
      align="center"
      sx={{
        p: 4,
        flex: 1,
        width: '100%',
        maxWidth: '500px',
        margin: '0 auto',
      }}
    >
      <Sound url={item.url} add={handleAddSound} handleDelete={handleDeleteSound} />
    </MemreFlexBox>
  );
}
